export function resolveMessagesBroadcasts(newProjectId: string): boolean {
  const currentTab = new URLSearchParams(window.location.search).get('tab_name')
  if (currentTab !== 'broadcasts') return false

  const checkbox = document.querySelector<HTMLInputElement>(
    `.broadcast-filters-group[data-filter="project_ids"][value="${newProjectId}"]`
  )
  if (!checkbox) return false

  document.querySelectorAll<HTMLInputElement>('.broadcast-filters-group').forEach((cb) => {
    cb.checked = false
  })

  checkbox.checked = true
  checkbox.dispatchEvent(new Event('change', { bubbles: true }))
  return true
}
